<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0">Hak Akses</h4>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <Link href="/admin/roles">Hak Akses</Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">Manajemen Hak Akses</h4>
                  <!-- <p class="card-title-desc mb-0">Memuat nama atau tolok indikator, satuan, dan entitas selain data. Anda juga dapat untuk menampilkan atau tidak pada halaman muka.</p> -->
                </div>
                <div>
                  <button type="button" class="btn btn-success" @click="form.show = true">Tambah Baru</button>
                </div>
              </div>

              <hr>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead>
                    <tr>
                      <th class="text-center">#</th>
                      <th>Role</th>
                      <th>Perubahan Terakhir</th>
                      <th class="text-center">Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in roles" :key="index">
                      <td scope="row" class="text-center">{{ index + 1 }}</td>
                      <td scope="row" v-text="row.name"></td>
                      <td scope="row">{{ (new Date(row.updated_at)).toLocaleString() }}</td>
                      <td scope="row" class="text-center">
                        <a @click="edit(row)" class="p-0 btn btn-sm btn-link">Edit</a> | 
                        <a @click="remove(row)" class="p-0 btn btn-sm btn-link">Hapus</a>
                      </td>
                    </tr>
                    <tr v-if="roles.length == 0">
                      <td scope="row" colspan="6" class="text-center">
                        <i>Tidak ditemukan data!</i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
    </div>
    <!-- container-fluid -->
  </div>

  <modal :show="form.show" @close="form.show = false" :title="(form.id ? 'Ubah': 'Tambah') + ' Hak Akses'" backdrop="static">
    <template #default>
      <form @submit.prevent="action">
        <div class="mb-3">
          <label for="name" class="form-label">Urai Role</label>
          <input v-model="form.name" type="text" class="form-control" id="name" />
        </div>
      </form>
    </template>
    <template #footer>
      <button type="button" class="btn btn-primary" @click="action">Simpan</button>
    </template>
  </modal>
</template>

<script>
import Layout from '@/layout/Index'
import Modal from '@/components/Modal'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'

export default {
  layout: Layout,
  components: { Modal },
  props: {
    roles: Array
  },
  data() {
    return {
      form: {
        show: false,
        id: null,
        name: ''
      },
    }
  },
  methods: {
    edit({ id, name }) {
      this.form.id = id;
      this.form.name = name;
      this.form.show = true;
    },
    action() {
      if(this.form.id) {
        this.$inertia.put('/admin/roles/' + this.form.id, this.form);
      } else {
        this.$inertia.post('/admin/roles', this.form);
      }
      this.form.show = false;
      this.form.id = null;
      this.form.name = '';
    },
    remove(row) {
      if(confirm('Hapus Data?'))
      this.$inertia.delete('/admin/roles/' + row.id);
    }
  },
}
</script>
